import React, {PureComponent} from 'react';
import Login from './login/loginPage';
import Dashboard from './dashboard/dashboard';
import TeamInfo from './dashboard/popoutComponents/teamInfo';
import {Route} from 'react-router-dom';
import {Switch} from "react-router";
import i18next from "i18next";

import SessionChoice from "./login/sessionChoice";
import PopoutLapTimes from "./dashboard/popoutComponents/lapTimes";
import PopoutLapComparison from "./dashboard/popoutComponents/lapComparison";
import PopoutLapDetail from "./dashboard/popoutComponents/lapDetail";
import PopoutStream from "./dashboard/popoutComponents/stream";
import PopoutTrack from "./dashboard/popoutComponents/map";
import OrganizerPanel from "./dashboard/popoutComponents/organizerPanel";
import PopoutLiveTiming from "./dashboard/popoutComponents/liveTiming";
import PopoutLiveMaxes from "./dashboard/popoutComponents/liveMaxes";
import LandingPage from "./login/landingPage";
import PopoutMiniChallengeZones from "./dashboard/popoutComponents/miniChallengeZones";
import PopoutLiveTimingMiniChallenge from "./dashboard/popoutComponents/liveTimingMiniChallenge";
import PopoutLivePitSpeed from "./dashboard/popoutComponents/livePitSpeed";
import PopoutPitDetail from "./dashboard/popoutComponents/pitDetails";
import PopoutDiagMonitor from "./dashboard/popoutComponents/diagnostics";
import FlagMonitor from "./dashboard/popoutComponents/flagPanel";
import PopoutFlagIssueDetail from "./dashboard/popoutComponents/flagIssueDetails";
import Code60Monitor from "./dashboard/popoutComponents/code60monitor";
import SessionStatusHistory from "./dashboard/popoutComponents/sessionStatusHistory";
import ScreenChoice from "./login/screenChoice";
import SeatTimeMonitor from "./dashboard/popoutComponents/seatTimeMonitor";
import RedirectPlatform from "./login/redirectPlatform";
import ClearCache from 'react-clear-cache';
import {Modal} from "react-responsive-modal";

import {withTranslation} from "react-i18next";
import {withCookies} from 'react-cookie';

import './css/elements/bars.css';
import './css/elements/spinner_loading.css';
import './css/elements/custom_checkbox.css';
import './css/elements/scrollbar_style.css';
import './css/elements/custom_radio_button.css';
import './css/elements/zoomAnimation.css';
import './css/elements/map_elements.css';
import './css/elements/sidebar.css';
import './css/elements/curtain.css';
import './css/elements/modal.css';
import './css/effects.css';
import './css/dirty_fixes.css';

import 'ol/ol.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';
import 'react-responsive-modal/styles.css';

import './css/bootstrap_class_modifications.css';
import './css/common_classes.css';
import './css/mediaQueries_smartphone.css';

class App extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            lang: "en",
            modalOpen: true,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        let currentLang;
        if (!this.props.cookies.get("lang")) {
            currentLang = i18next.languages[0].split("-")[0].toLowerCase();
            this.props.cookies.set("lang", currentLang, {"path": "/", "maxAge": (4 * 24 * 60 * 60)});
        } else {
            currentLang = this.props.cookies.get("lang");
        }
        this.setState({lang: currentLang});
        this.props.i18n.changeLanguage(currentLang).then();
    }

    /* HANDLER */
    openModal() {
        this.setState({
            modalOpen: true,
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false,
        });
    }

    render() {
        return (
            <>
                <ClearCache>
                    {({isLatestVersion, emptyCacheStorage}) => (
                        <div>
                            {!isLatestVersion && (
                                <p>
                                    <button className={"btn App_big_white_text"} style={{background: "#ff0003", color: "#FFFFFF", margin: 20}} onClick={this.openModal}>
                                        <span><i className={"fas fa-lightbulb"}/></span>
                                        <span>{this.props.t("updateAppVersion")}</span>
                                    </button>
                                    <Modal open={this.state.modalOpen}
                                           onClose={this.closeModal}
                                           center={false}
                                           classNames={{modal: "small-modal"}}
                                           showCloseIcon={false}
                                    >
                                        <div className={"modal-header"}>
                                            <div className={"modal-title"}>
                                                <span className={"App_black_text"} style={{fontSize: 25}}><b>{this.props.t("updateAppVersion")}</b></span>
                                            </div>
                                        </div>
                                        <div className={"modal-body"}>
                                            <p className={"App_big_black_text"}>{this.props.t("updateAppVersionDescription")}</p>
                                        </div>
                                        <div className={"modal-footer"}>
                                            <button
                                                onClick={e => {
                                                    e.preventDefault();
                                                    emptyCacheStorage();
                                                }}
                                                className={"btn App_white_text"}
                                                style={{background: "#ff0003", color: "#FFFFFF"}}
                                                disabled={!this.state.transitionCountdown && this.state.transitionFlag > 0}
                                            >{this.props.t("update")}
                                            </button>
                                        </div>
                                    </Modal>
                                </p>
                            )}
                        </div>
                    )}
                </ClearCache>
                <Switch>
                    <Route exact path={"/sessionChoice"} render={({location}) => (<SessionChoice location={location}/>)}/>
                    <Route exact path={"/screenChoice"} render={({location}) => (<ScreenChoice location={location}/>)}/>
                    <Route exact path={"/dashboard"} render={({location}) => (<Dashboard location={location}/>)}/>
                    <Route exact path={"/external-redirect/:action"} component={RedirectPlatform}/>
                    <Route path={"/public/:eventShareCode"} render={({match}) => (<LandingPage match={match}/>)}/>
                    <Route path={"/teamInfo/:userID/:carID/:sessionID/:eventID"} render={({match}) => (<TeamInfo match={match}/>)}/>
                    <Route path={"/expandMap/:eventID/:sessionID/:carID/:windowWidth"} render={({match}) => (<PopoutTrack match={match}/>)}/>
                    <Route path={"/expandLapTimes/:eventID/:sessionID/:carID"} render={({match}) => (<PopoutLapTimes match={match}/>)}/>
                    <Route path={"/lapComparison/:eventID/:sessionID/:lapUUIDs"} render={({match}) => (<PopoutLapComparison match={match}/>)}/>
                    <Route path={"/lapDetails/:eventID/:sessionID/:lapUUID"} render={({match}) => (<PopoutLapDetail match={match}/>)}/>
                    <Route path={"/liveTiming/:eventID/:sessionID/:userID"} render={({match}) => (<PopoutLiveTiming match={match}/>)}/>
                    <Route path={"/expandStream/:streamID"} render={({match}) => (<PopoutStream match={match}/>)}/>
                    <Route path={"/organizerPanel/:userID/:eventID/:sessionID/"} render={({match}) => (<OrganizerPanel match={match}/>)}/>
                    <Route path={"/miniChallengeZones/:eventID/:sessionID/:carID/:userID"} render={({match}) => (<PopoutMiniChallengeZones match={match}/>)}/>
                    <Route path={"/miniChallengeLive/:eventID/:sessionID/:userID"} render={(match) => (<PopoutLiveTimingMiniChallenge match={match}/>)}/>
                    <Route path={"/liveMaxes/:eventID/:sessionID/:userID"} render={({match}) => (<PopoutLiveMaxes match={match}/>)}/>
                    <Route path={"/livePitSpeed/:eventID/:sessionID/:userID"} render={({match}) => (<PopoutLivePitSpeed match={match}/>)}/>
                    <Route path={"/pitDetails/:eventID/:sessionID/:carID/:entry/:exit/:userID/:mapZoomLevel/:mapRotation/:pitEntryLat/:pitEntryLng/:pitExitLat/:pitExitLng"} render={({match}) => (<PopoutPitDetail match={match}/>)}/>
                    <Route path={"/flagIssueDetails/:eventID/:sessionID/:carID/:issue/:clear/:userID/:mapCenterLat/:mapCenterLng/:mapZoomLevel/:mapRotation/:issueID/:speedThreshold"} render={({match}) => (<PopoutFlagIssueDetail match={match}/>)}/>
                    <Route path={"/diagnostic/:eventID/:sessionID/:userID"} render={({match}) => (<PopoutDiagMonitor match={match}/>)}/>
                    <Route path={"/flagMonitor/:eventID/:sessionID/:userID"} render={({match}) => (<FlagMonitor match={match}/>)}/>
                    <Route path={"/code60monitor/:eventID/:sessionID/:userID/:issueID"} render={({match}) => (<Code60Monitor match={match}/>)}/>
                    <Route path={"/sessionStatusHistory/:eventID/:sessionID/:userID"} render={({match}) => (<SessionStatusHistory match={match}/>)}/>
                    <Route path={"/seatTimeMonitor/:eventID/:sessionID/:userID"} render={({match}) => (<SeatTimeMonitor match={match}/>)}/>
                    <Route path={"/:lang/:userID"} render={({match}) => (<Login match={match}/>)}/>
                    <Route exact path={"/"} render={() => (<Login/>)}/>
                </Switch>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(App));
